var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 4.4C24 3.08 22.92 2 21.6 2H2.4C1.08 2 0 3.08 0 4.4V18.8C0 20.12 1.08 21.2 2.4 21.2H21.6C22.92 21.2 24 20.12 24 18.8V4.4ZM21.6 4.4L12 10.4L2.4 4.4H21.6ZM21.6 18.8H2.4V6.8L12 12.8L21.6 6.8V18.8Z",
    fill: "#0059B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutline);
export default __webpack_public_path__ + "static/media/Email-Outline.a3d241cec08c9f9794cbb70b955e7ff3.svg";
export { ForwardRef as ReactComponent };